import { setActiveTokenHash, setSessionState } from './hooks';

const buttonStyle: React.CSSProperties = {
  background: '#e09020',
  color: '#1a1208',
  border: 'none',
  padding: '14px 36px',
  fontSize: 18,
  borderRadius: 6,
  cursor: 'pointer',
  fontFamily: 'inherit',
  letterSpacing: 0.5,
};

const linkStyle: React.CSSProperties = {
  background: 'transparent',
  color: '#9bb0d4',
  border: 'none',
  padding: 0,
  marginTop: 18,
  fontSize: 13,
  fontFamily: 'inherit',
  cursor: 'pointer',
  textDecoration: 'underline',
};

/**
 * First-time-visitor welcome screen.
 *
 * Shown when there are zero saved identities locally. Asks for an
 * intentional click before creating a character — landing → /play
 * should never silently spawn a squirrel.
 *
 * Two actions:
 *  - Enter the canopy → CONNECTING (no token) → auto enterWorld → PLAYING
 *  - Select your character → IDENTITY_SELECT (the empty picker, where
 *    Import lets the user load a saved identity from a file — useful
 *    for testing in incognito browsers and for cross-device portability).
 */
export function Welcome() {
  const enter = () => {
    setActiveTokenHash('');
    setSessionState('CONNECTING');
  };

  const selectCharacter = () => {
    setSessionState('IDENTITY_SELECT');
  };

  return (
    <div
      style={{
        height: '100vh',
        width: '100vw',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        background:
          'radial-gradient(circle at 50% 35%, #1a2438 0%, #0a0e18 70%)',
        color: '#e7d9b6',
        fontFamily: 'Georgia, serif',
        textAlign: 'center',
      }}
    >
      <div style={{ maxWidth: 480, padding: 24 }}>
        <p
          style={{
            fontSize: 14,
            opacity: 0.55,
            margin: 0,
            letterSpacing: 1,
            textTransform: 'uppercase',
          }}
        >
          Welcome
        </p>
        <h1
          style={{
            fontSize: 40,
            margin: '6px 0 4px',
            fontWeight: 400,
          }}
        >
          to Heartwood
        </h1>
        <p style={{ opacity: 0.6, fontStyle: 'italic', marginBottom: 32 }}>
          The forest will name you.
        </p>
        <div
          style={{
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
          }}
        >
          <button onClick={enter} style={buttonStyle}>
            Begin your adventure →
          </button>
          <button onClick={selectCharacter} style={linkStyle}>
            Select your character
          </button>
        </div>
      </div>
    </div>
  );
}
